import React from "react";
import "./Service.css";
import html from"./img/html.png"
import css from"./img/css.png"
import react from"./img/react.png"
import mongodb from"./img/mongodb.png"
import express from"./img/express.png"
import js from "./img/pngwing.com.png"
import node from "./img/node.png"
import typescript from "./img/typescript.png"

function Service() {
  return (
    <div className="service component__space" id="Services">

      <div className="heading">
        <h1 className="heading">Technical Skills</h1>
       
      </div>

      <div className="container">
        <div className="row">
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <img  height="50px"
                  width="50px" src={html}/>
                {/* <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                  <line x1="2" y1="20" x2="2" y2="20"></line>
                </svg> */}
              </div>
              <div className="service__meta">
                <h1 className="service__text">Html</h1>
                {/* <p className="p service__text p__color">
                  I throw myself down among the
                </p>
                <p className="p service__text p__color">
                  tall grass by the stream as I lie
                </p>
                <p className="p service__text p__color">close to the earth.</p> */}
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <img height="50px"
                  width="50px" src={css}/>
              </div>
              <div className="service__meta">
                <h1 className="service__text">Css</h1>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="50px" src={js}/>
                {/* <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg> */}
              </div>
              <div className="service__meta">
                <h1 className="service__text">JavaScript</h1>
                {/* <p className="p service__text p__color">
                  I throw myself down among the
                </p>
                <p className="p service__text p__color">
                  tall grass by the stream as I lie
                </p>
                <p className="p service__text p__color">close to the earth.</p> */}
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="50px" src={react}/>
                {/* <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg> */}
              </div>
              <div className="service__meta">
                <h1 className="service__text">React.js</h1>
                {/* <p className="p service__text p__color">
                  I throw myself down among the
                </p>
                <p className="p service__text p__color">
                  tall grass by the stream as I lie
                </p>
                <p className="p service__text p__color">close to the earth.</p> */}
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="50px" src={mongodb}/> 
              </div>
              <div className="service__meta">
                <h1 className="service__text">MongoDB</h1>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="90px" src={express}/>
              </div>
              <div className="service__meta">
                <h1 className="service__text">Express.js</h1>
              </div>     
            </div>
          </div>

          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="50px" src={node}/>
              </div>
              <div className="service__meta">
                <h1 className="service__text">Node.js</h1>
              </div>     
            </div>
            </div>
            <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
              <img height="50px"
                  width="70px" src={typescript}/>
              </div>
              <div className="service__meta">
                <h1 className="service__text">TypeScript</h1>
              </div>     
            </div>
          </div>
         
        </div>
      </div>
    </div>
  );
}

export default Service;
